import '../game.css';
const React = require('react');
const { DropTarget } = require('react-dnd');
const dragType = require('../../../define/dragType').default;
// ============================

const style = require('../game.style').default;

const OverlayPanel = ({ color }) => {
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex: 1,
                opacity: 0.5,
                backgroundColor: color,
            }}
        />
    )
}

const Panel = ({ isDark, children }) => {
    const backgroundColor = isDark ? '#BBB' : '#FFF';
    return (
        <div
            style={{
                height: '100%',
                width: '100%',
                backgroundColor
            }}
        >
            {children}
        </div>
    )
}

const dropSpec = {
    drop(props, monitor) {
        if (monitor.didDrop()) { return }
        props.onDrop(monitor.getItemType(), monitor.getItem());
    }
}

const collect = (connect, monitor) => {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: !!monitor.isOver({ shallow: true }),
        itemType: monitor.getItemType(),
        dragItem: monitor.getItem()
    }
}

class panelComponent extends React.Component {
    componentDidUpdate(prevProps) {
        if (!prevProps.isOver && this.props.isOver) {
            this.props.onHoverEvent(true, this.props.itemType, this.props.dragItem);
        }

        if (prevProps.isOver && !this.props.isOver) {
            this.props.onHoverEvent(false, this.props.itemType, this.props.dragItem);
        }
    }
    /*
    constructor(props) {
        super(props);
        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.onDrop = this.onDrop.bind(this);
    }

    onDragEnter() {
        this.props.onEnterPanel();
    }
    onDragLeave() {
        this.props.onLeavePanel();
    }

    renderObject() {
        return (
            <dev onDragEnter={this.onDragEnter} onDragLeave={this.onDragLeave} on={this.onDrop}>
                {Panel(this.props.object, this.props.hp, this.props.selected)}
            </dev>
        )
    }
*/
    render() {
        const { posX, posY } = this.props;
        const isDark = (posX + posY) % 2 === 1;
        return this.props.connectDropTarget(
            <div style={style.panelStyle}>
                <Panel isDark={isDark}>{this.props.children}</Panel>
                {this.props.isOver && <OverlayPanel color="red" />}
                {this.props.placement && <OverlayPanel color="green" />}
            </div>
        )
    }
}

export default DropTarget(
    [dragType.PORIN_BOX, dragType.SKILL],
    dropSpec,
    collect
)(panelComponent)